import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { useAddDeviceFormCtx } from './AddDeviceFormProvider';

export const DeviceDetailsForm = () => {
  const form = useAddDeviceFormCtx();
  const { control } = form;

  return (
    <div className="space-y-4">
      <FormField
        control={control}
        name="serialNumber"
        render={({ field, fieldState }) => {
          return (
            <FormItem className="flex-1" data-onboarding="add-device-serial-number">
              <FormLabel>Serial Number (Optional)</FormLabel>
              <FormControl>
                <Input
                  id="serialNumber"
                  placeholder="Enter serial number"
                  {...field}
                  className={fieldState.error ? 'border-red-500' : ''}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          );
        }}
      />
      <FormField
        control={control}
        name="description"
        render={({ field, fieldState }) => {
          return (
            <FormItem>
              <FormLabel>Description (Optional)</FormLabel>
              <FormControl>
                <Textarea
                  id="description"
                  placeholder="Enter device description or notes"
                  {...field}
                  className={fieldState.error ? 'border-red-500' : ''}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          );
        }}
      />
    </div>
  );
};
